import CsvLogoIcon from 'assets/icons/csvLogo.svg';
import DeleteIcon from 'assets/icons/delete.svg';

export interface ProgressBarProps {
  file: File;
  onDelete: () => void;
}

function ProgressBar(props: ProgressBarProps) {
  return (
    <div className="ct_progBar">
      <div className="ct_progBar-icon">
        <CsvLogoIcon />
      </div>
      <div className="ct_progBar-content">
        <div className="ct_progBar-header">
          <div className="ct_progBar-name">{props.file.name}</div>
          <div className="ct_progBar-action">
            <button type="button" className="ct_btn _delete" onClick={props.onDelete}>
              <DeleteIcon />
            </button>
          </div>
        </div>
        <div className="ct_progBar-bar">
          <span style={{ width: '100%' }} />
        </div>
        <div className="ct_progBar-info">
          {`${props.file.size / 1000} KB`}
        </div>
      </div>
    </div>
  );
}

export default ProgressBar;
